<template>
    <div>
        <p class="slds-p-bottom_small">
            <span>We need to know what location information is in your CSV. Please map all applicable column headers below. Here are the minimum </span>
            <MATooltip
                :showIcon="true"
                class="inline-block"
                :nubbin="left"
            >
                <span
                    slot="icon"
                    class="slds-text-link inline-block"
                >
                    location requirements.
                </span>
                <div
                    slot="content"
                    class="slds-popover__body"
                >
                    <div class="slds-p-vertical_x-small">
                        We require the following information. Additional information increases the accuracy of your locations on the map.
                    </div>
                    <div class="slds-box slds-box_small">
                        <p>Latitude + Longitude</p>
                    </div>
                    <div class="slds-p-vertical_x-small">
                        - OR -
                    </div>
                    <div class="slds-box slds-box_small slds-p-vertical_x-small">
                        <p>One or more address field (Street, City, ZIP Code, State, Country)</p>
                    </div>
                </div>
            </MATooltip>
        </p>
        <div
            id="spatial-reference-columns"
        >
            <fieldset class="slds-form-element slds-form_compound">
                <div class="slds-form-element__control">
                    <div class="slds-form-element__group">
                        <div class="slds-form-element__row slds-wrap">
                            <div
                                v-for="(column, i) in Object.keys(store__spatialReference)"
                                :key="i"
                                class="cols slds-form-element slds-size_1-of-3"
                            >
                                <MAPicklist
                                    v-model="store__spatialReference[column].index"
                                    :label="store__spatialReference[column].label"
                                    :options="store__schema"
                                    :isRequired="column == 'name'"
                                    doDetach="true"
                                    keyString="index"
                                    valueString="label"
                                    :placeholder="`Select ${store__spatialReference[column].label} Column`"
                                    class="slds-form-element__control slds-m-bottom_medium fixed-width"
                                    @input="store__updateSchemaElement(store__spatialReference[column])"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</template>

<script>

import { mapState, mapMutations } from 'vuex';
import MAPicklist from '@mapanything/ma-lib/src/vue/components/MAPicklist.vue';
import MATooltip from '@mapanything/ma-lib/src/vue/components/MATooltip.vue';

export default {
    name: 'SpatialReference',
    components: {
        MAPicklist,
        MATooltip
    },
    computed: {
        ...mapState({
            store__dataset: 'dataset',
            store__schema: 'schema',
            store__spatialReference: 'spatialReference'
        })
    },
    created() {
        this.pushHeadersToSchema();
    },
    methods: {
        ...mapMutations({
            store__markSpatialReferenceAsDone: 'markSpatialReferenceAsDone',
            store__addToSchema: 'addToSchema',
            store__updateSchemaElement: 'updateSchemaElement'
        }),
        pushHeadersToSchema() {
            if (this.store__dataset.headers.length > 0) {
                this.store__dataset.headers.forEach((header, i) => {
                    const cleanHeader = this.cleanHeader(header);

                    this.store__addToSchema({
                        rawLabel: cleanHeader,
                        renamedLabel: cleanHeader,
                        label: cleanHeader,
                        index: i,
                        spatial: undefined,
                        format: 'string',
                        active: true
                    });
                });
            }
        },
        cleanHeader(header) {
            const cleanHeader = header.replace(/"/g, '');
            return cleanHeader;
        }
    }
};
</script>

<style lang="scss" scoped>
    /deep/ .slds-popover_tooltip {
        display: none;
        position: absolute;
        visibility: visible;
        opacity: 1;
        overflow: visible;
        cursor: default;
        z-index: 9999;

        .slds-popover__body {
            white-space: normal;
            padding: .75rem;
        }
    }

    #spatial-reference-columns .cols:first-child {
        padding-left: .5rem;
    }
</style>
